import clsx from 'clsx'
import React, { CSSProperties, useContext } from 'react'

import SvgAngleRight from '@Assets/SVG/AngleRight'
import SvgClubTrendhim from '@Assets/SVG/ClubTrendhim'
import { Link } from '@Components/Link'
import { ClubInfo } from '@Domains/Club/Components/ClubInfo'
import { useClub } from '@Domains/Club/Hook'
import { MetadataContext } from '@Globals/Metadata'
import { useTranslation } from '@Globals/Translations'

import styles from './ClubEstimate.module.scss'

export const ClubEstimate = ({
  cashback,
  className,
  forceIsLoggedIn = false,
  style,
}: {
  cashback?: string
  className?: string
  forceIsLoggedIn?: boolean
  style?: CSSProperties
}) => {
  const { t, tDanger } = useTranslation()
  const { storeURL } = useContext(MetadataContext)
  const { isLoggedIn: isLoggedInReal, setModalState } = useClub()

  const isLoggedIn = forceIsLoggedIn || isLoggedInReal

  return (
    <div className={clsx(styles.wrapper, className)} style={style}>
      <div className={styles.clubEstimate}>
        <SvgClubTrendhim className={styles.clubTrendhim} />
        <div className={styles.textWrapper}>
          {!isLoggedIn && (
            <>
              <span className={styles.text}>{t('common:TRENDHIMCLUB_GET_CASHBACK_ON_FIRST_ORDER', { percentage: '15' })}</span>
              <Link className={styles.learnMore} href={storeURL('account/benefits')}>{t('common:TRENDHIMCLUB_LEARN_MORE_LABEL')}</Link>
            </>
          )}
          {isLoggedIn && <span className={styles.text} {...tDanger('common:TRENDHIMCLUB_MAIN_CTA_1_DYNAMIC', { percentage: 15 })} />}
        </div>
        <div className={styles.earning}>
          {isLoggedIn && (
            <span
              className={styles.authEstimate}
              {
              ...cashback
                ? tDanger('common:TRENDHIMCLUB_YOU_JUST_EARNED_CASHBACK', { amount: cashback })
                : tDanger('common:TRENDHIMCLUB_TRUSTED_BY_X_MEMBERS')
            }
            />
          )}
          {!isLoggedIn && (
            <>
              <span
                className={styles.estimate}
                {...cashback
                  ? tDanger('common:TRENDHIMCLUB_YOU_JUST_EARNED_CASHBACK', { amount: cashback })
                  : tDanger('common:TRENDHIMCLUB_TRUSTED_BY_X_MEMBERS')}
              />
              <button className={styles.join} onClick={() => setModalState('EMAIL_DECISION')} type="button">{t('common:JOIN_LABEL', 'JOIN')}</button>
            </>
          )}
        </div>
        {isLoggedIn && (
          <Link
            analytics={{
              dest_page_type: 'account-overview',
              dest_page_type_id: '',
              source_id: 'header',
            }}
            className={styles.goToProfile}
            href={storeURL('account/overview')}
          >
            <SvgAngleRight />
            <span>{t('common:TRENDHIMCLUB_GO_TO_DASHBOARD')}</span>
          </Link>
        )}
      </div>
      <ClubInfo className={styles.clubInfo} itemClassName={styles.clubInfoItem} />
    </div>
  )
}

